import {ActionEnum} from "../action.enum";

export namespace ChecklistTemplateEntryReorderAction {

  export class DragStarted {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_REORDER_DRAG_STARTED;
    constructor (public blockIndex: number) {}
  }

  export class DragIndexChanged {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_REORDER_DRAG_INDEX_CHANGED;
    constructor (public newIndex: number) {}
  }

  export class DragEnded {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_REORDER_DRAG_ENDED;
  }

  export class MoveBack {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_REORDER_MOVE_BACK;
    constructor (public id: string) {}
  }

  export class MoveForward {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_REORDER_MOVE_FORWARD;
    constructor (public id: string) {}
  }

  export class ResetState {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_ENTRY_REORDER_RESET_STATE;
  }

}
